"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const services_1 = require("@zapier/services");
const react_1 = require("react");
const buttonCss = core_1.css `
  background-color: ${design_system_1.Colors.grey000};
  transition: all 0.15s ease-in-out;
  border: solid ${design_system_1.Colors.grey000} 1px;
  border-radius: 10px;
  padding: 20px;

  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

  &:hover,
  &:focus {
    background-color: ${design_system_1.Colors.white};
    border: solid ${design_system_1.Colors.grey200} 1px;
    box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    .name {
      color: ${design_system_1.Colors.blue500};
    }
  }

  /* Enable the focus-specific psuedo element to be properly positioned */
  position: relative;

  transition-property: all;
  transition-timing-function: ${design_system_1.Animation.transitionTimingFunction};
  transition-duration: ${design_system_1.Animation.transitionDuration};

  /* Focus-specific pseudo-element to match ZDS focus outlines */
  &::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 2px;
    right: 2px;
    bottom: 2px;
    left: 2px;
    border: 2px solid transparent;
    border-radius: 10px;
    transition-property: all;
    transition-timing-function: ${design_system_1.Animation.transitionTimingFunction};
    transition-duration: ${design_system_1.Animation.transitionDuration};
  }
  &:focus {
    &::before {
      border-color: ${design_system_1.Colors.blue500};
      top: -1px;
      right: -1px;
      bottom: -1px;
      left: -1px;
    }
  }
`;
const containerCss = core_1.css `
  display: flex;
  align-items: start;
`;
const labelContainerCss = core_1.css `
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;
const appNameWrapperCss = core_1.css `
  color: ${design_system_1.Colors.black};
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
`;
function FeaturedAppButton({ app: { banner, name, subtitle, key, iconUrl }, onClick, }) {
    const onSelect = react_1.useCallback(() => onClick(key), [onClick, key]);
    return (common_utils_1.isolateComponent("button", { "aria-label": `Select ${name}`, css: buttonCss, onClick: onSelect },
        common_utils_1.isolateComponent("div", { css: containerCss },
            common_utils_1.isolateComponent(design_system_1.Img, { alt: "", hasRadius: false, height: 40, lazyloadOffset: null, src: iconUrl, width: 40 }),
            common_utils_1.isolateComponent("div", { css: labelContainerCss },
                common_utils_1.isolateComponent("div", { className: "name" },
                    common_utils_1.isolateComponent("span", { css: appNameWrapperCss },
                        common_utils_1.isolateComponent(design_system_1.Text, { color: "inherit", fontWeight: 600, type: "bodyText800" }, name)),
                    common_utils_1.isolateComponent(services_1.AppBanner, { banner: banner })),
                common_utils_1.isolateComponent(design_system_1.Text, { color: "grey700", type: "altText900" }, subtitle)))));
}
exports.default = FeaturedAppButton;
